import React from "react";
import { Link } from "react-router-dom";
import { Cloud, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

const PaymentCancel = () => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-background px-5">
    <Link to="/" className="absolute left-6 top-6 flex items-center gap-2">
      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
        <Cloud className="h-5 w-5" strokeWidth={2.2} />
      </span>
      <span className="font-display text-xl font-bold">Nimbus</span>
    </Link>
    <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-lg">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary">
        <XCircle className="h-10 w-10 text-muted-foreground" />
      </div>
      <h1 className="mt-5 font-display text-2xl font-bold text-foreground">Checkout canceled</h1>
      <p className="mt-2 text-muted-foreground">No worries — you weren't charged. You can pick a plan whenever you're ready.</p>
      <div className="mt-7 flex gap-3">
        <Button asChild variant="outline" className="flex-1 rounded-full">
          <Link to="/">Back to site</Link>
        </Button>
        <Button asChild className="flex-1 rounded-full bg-primary font-semibold">
          <Link to="/workspace">Try the demo</Link>
        </Button>
      </div>
    </div>
  </div>
);

export default PaymentCancel;
